import { render, staticRenderFns } from "./ImageAttachment.vue?vue&type=template&id=8d9b8e96&scoped=true&"
import script from "./ImageAttachment.vue?vue&type=script&lang=js&"
export * from "./ImageAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttachment.vue?vue&type=style&index=0&id=8d9b8e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9b8e96",
  null
  
)

export default component.exports